import React, { Component } from 'react';
import axios from "axios";
import {appConfig} from "../../tools/AppConfig";
import Waiting from '../waiting';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Select from 'react-validation/build/select';
import Button from 'react-validation/build/button';
import './../../custom.css';
import './../../pages/invoice.css';
import './installments.css';
import visaImg from './../../../statics/img/visa.svg';
import creditImg from './../../../statics/img/credit.svg';
import AAIBLogoImg from './../../../statics/img/AAIB-logo.png';
import acceptBlueImg from './../../../statics/img/accept_blue.png';
import validator from 'validator';
const required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> This field is required.</div>;
  }
};
const CreditCard = (value) => {
    let regex = new RegExp("^[0-9]{16}$");
    if (!regex.test(value)) {
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter a valid card number.</div>;
    };
}
const Cvv = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length < 3 || value.toString().trim().length > 4 ){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid CVV.</div>;
    }
};
const FullName = (value) => {
    var patt = new RegExp("[a-zA-Z]+ [a-zA-Z]+");
    if(!patt.test(value)){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid card holder name.</div>;
    }
};

class installments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            waiting: false,
            userData: props.userData,
            deliveryNeed: props.deliveryNeed,
            deliveryData: props.deliveryData,
            cardNumber: '',
            cardHolderName: '',
            expiryMonth: '',
            expiryYear: '',
            cvv: '',
            tenure: '',
            active_bank: null,
            active_plan: null
        };
        this.getFirstName = this.getFirstName.bind(this);
        this.getLastName = this.getLastName.bind(this);
        this.handleCardNumChange = this.handleCardNumChange.bind(this);
        this.handleCardNumValueChange = this.handleCardNumValueChange.bind(this);
        this.handelCardHolderName = this.handelCardHolderName.bind(this);
        this.handelCardHolderNameValue = this.handelCardHolderNameValue.bind(this);
        this.handelExpiryMonthChange = this.handelExpiryMonthChange.bind(this);
        this.handelExpiryYearChange = this.handelExpiryYearChange.bind(this);
        this.handelCVVChange = this.handelCVVChange.bind(this);
        this.handelCVVValueChange = this.handelCVVValueChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount(){
        this.setState({tenure: this.state.userData.bank_installment[0].plans[0].tenure})
    }

  getFirstName(fullName) {
    var namesArr = fullName.split(" ");
    return namesArr[0]
  }
  getLastName(fullName) {
    var namesArr = fullName.split(" ");
    return namesArr[namesArr.length - 1];
  }
  handleCardNumChange(e) {
    this.setState({cardNumber: e.target.value});
  }
  handleCardNumValueChange(value) {
    this.setState({cardNumber: value});
  }
  handelCardHolderName(e) {
    this.setState({cardHolderName: e.target.value});
  }
  handelCardHolderNameValue(value) {
    this.setState({cardHolderName: value});
  }
  handelExpiryMonthChange(e) {
      this.setState({expiryMonth: e.target.value});
  }
  handelExpiryYearChange(e) {
    this.setState({expiryYear: e.target.value});
  }
  handelCVVChange(e) {
    this.setState({cvv: e.target.value});
  }
  handelCVVValueChange(value) {
    this.setState({cvv: value});
  }
  handleChooseBank = (index) => {
    this.setState({
        active_bank: index,
        tenure: this.state.userData.bank_installment[index].plans[0].tenure,
        active_plan: null
    });
  }
  handleChoosePlan = (tenure, index) => {
    this.setState({tenure, active_plan: index});
  }
  handleSubmit(event) {
    //start waiting
    this.setState({waiting: true});
    //disable payment method options
    this.props.disableAllPaymentMethods();
    //post req
    let url;
    if(this.props.sourcePage ==='invoice'){
        url = appConfig.getServerUrl() + '/invoice2/'+ this.state.userData.token;
    }else if(this.props.sourcePage ==='product'){
        url = appConfig.getServerUrl() + '/product2/'+ this.state.userData.token;
    }
    let paymentDict;
    if(this.props.sourcePage ==='invoice'){
        paymentDict = {
            "source": {
                "identifier": this.state.cardNumber,
                "sourceholder_name": this.state.cardHolderName,
                "expiry_month": this.state.expiryMonth,
                "expiry_year": this.state.expiryYear,
                "cvn": this.state.cvv,
                "subtype": "CARD",
                "tenure": this.state.tenure
            }, "shipping_data": {
                'apartment': "",
                'email': this.state.userData.order_email,
                'floor': "",
                'first_name': this.getFirstName(this.state.userData.order_full_name),
                'street': "",
                'building': "",
                'phone_number': this.state.userData.order_phone,
                'postal_code': "",
                'city': "",
                'country': "",
                'last_name': this.getLastName(this.state.userData.order_full_name),
                'state': "",
                'extra_description': ''
            },
            "token": this.state.userData.token,
            "integration_id": this.state.userData.integration_ids.VPC
        };
        if(this.state.deliveryNeed){
            paymentDict.shipping_data.country = this.state.deliveryData.country;
            paymentDict.shipping_data.state = this.state.deliveryData.state;
            paymentDict.shipping_data.city = this.state.deliveryData.city;
            paymentDict.shipping_data.building = this.state.deliveryData.building;
            paymentDict.shipping_data.street = this.state.deliveryData.street;
            paymentDict.shipping_data.floor = this.state.deliveryData.floor;
            paymentDict.shipping_data.apartment = this.state.deliveryData.apartment;
            paymentDict.shipping_data.postal_code = this.state.deliveryData.postal_code;
            paymentDict.shipping_data.extra_description = this.state.deliveryData.notes;
        }
    }else if(this.props.sourcePage ==='product'){
        paymentDict = {
            "order_data": {
                "delivery_needed": this.state.deliveryNeed,
                "amount_cents": this.state.userData.amount * this.props.quantity * 100,
                "currency": this.state.userData.currency,
                "shipping_data": {
                    "first_name": this.getFirstName(this.state.deliveryData.name),
                    "last_name": this.getLastName(this.state.deliveryData.name),
                    "phone_number": this.state.deliveryData.phone,
                    "email": this.state.deliveryData.email,
                    "street": 'NA',
                    "city": 'NA',
                    "country": 'NA',
                    "postal_code": 'NA',
                    "state": "NA"
                },
                "items": [{
                    "name": this.state.userData.product.product_name,
                    "amount_cents": this.state.userData.amount * 100,
                    "quantity": this.props.quantity,
                }]
            },
            "source": {
                "identifier" : this.state.cardNumber,
                "sourceholder_name" : this.state.cardHolderName,
                "expiry_month" : this.state.expiryMonth,
                "expiry_year" : this.state.expiryYear,
                "cvn" : this.state.cvv,
                "subtype": "CARD",
                "tenure": this.state.tenure
            },
            "token": this.state.userData.token,
            "integration_id": this.state.userData.integrations.VPC,
        };
        if(this.state.deliveryNeed){
            paymentDict.order_data.shipping_data.country = this.state.deliveryData.country;
            paymentDict.order_data.shipping_data.state = this.state.deliveryData.state;
            paymentDict.order_data.shipping_data.city = this.state.deliveryData.city;
            paymentDict.order_data.shipping_data.building = this.state.deliveryData.building;
            paymentDict.order_data.shipping_data.street = this.state.deliveryData.street;
            paymentDict.order_data.shipping_data.floor = this.state.deliveryData.floor;
            paymentDict.order_data.shipping_data.apartment = this.state.deliveryData.apartment;
            paymentDict.order_data.shipping_data.postal_code = this.state.deliveryData.postal_code;
            paymentDict.order_data.shipping_data.extra_description = this.state.deliveryData.notes;
        }
    }


    let jsonPaymentDict = JSON.stringify(paymentDict);
    let config = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    axios.post(url, jsonPaymentDict, config)
    .then((resp) => {
        //enable payment methods
        this.props.enableAllPaymentMethods();
        //show result
        if(resp.data.success === true){
            if (resp.data.url) {
                window.location.href = resp.data.url;
            }else {
                //stop waiting
                this.setState({waiting: false});
                if(this.state.deliveryNeed){
                    //succes without url and delivery
                    this.props.setReqComplete({head: 'Transaction successful', body:'The Courier will be in touch to determine the exact collection time.'});
                }else{
                    //succes without url and not delivery
                    this.props.setReqComplete({head: 'Transaction successful', body:'Thank you for using the online payment service.'});
                }
            }
        }else{
            //succes = false
            this.props.setReqComplete({head: 'Transaction declined', body:'Please try again later. If this problem persists, please contact your service provider.'});
        }
    })
    .catch((err) => {
        //stop waiting
        this.setState({waiting: false});
        //enable payment methods
        this.props.enableAllPaymentMethods();
        if(err.response.status === 404){
            alert('Please check your internet connection and try again.');
        }
    });
    event.preventDefault();
  }
  renderForm = () => (
    <Form onSubmit={this.handleSubmit}>
        <div className="row">
            <div className="col-md-6 col-sm-12 col-xs-12">
                <div className="newInput">
                    <Input type="number"
                    pattern="[0-9]*"
                    name="c_pan_U"
                    placeholder="Card Number"
                    value={this.state.cardNumber}
                    onChange={(e) => {e.target.value.length <= 16 ?  this.handleCardNumChange(e) : this.handleCardNumValueChange(e.target.value.slice(0, 16))}}
                    validations={[required,CreditCard]}
                    />
                    <span className="visaIcon">
                        <img src={creditImg}/>
                        <img src={visaImg}/>
                    </span>
                </div>
            </div>
            <div className="col-md-6 col-sm-12 col-xs-12">
                <div className="newInput">
                    <Input type="text"
                    name="c_holder_name_U"
                    placeholder="Card Holder Name"
                    value={this.state.cardHolderName}
                    onChange={this.handelCardHolderName}
                    onChange={(e) => {/^[a-zA-Z\s]+$/.test(e.target.value)?  this.handelCardHolderName(e) : this.handelCardHolderNameValue(e.target.value.slice(0, e.target.value.length - 1))}}
                    validations={[required]}
                    />
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-4 col-sm-12 col-xs-12">
                <div className="newInput">
                    <Select
                    id="cardExMM"
                    name="c_expiry_mm_U"
                    required
                    value={this.state.expiryMonth}
                    onChange={this.handelExpiryMonthChange}
                    validations={[required]}
                    >
                        <option value="" disabled>MM</option>
                        <option value="01">01</option>
                        <option value="02">02</option>
                        <option value="03">03</option>
                        <option value="04">04</option>
                        <option value="05">05</option>
                        <option value="06">06</option>
                        <option value="07">07</option>
                        <option value="08">08</option>
                        <option value="09">09</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                    </Select>
                </div>
            </div>
            <div className="col-md-4 col-sm-12 col-xs-12">
                <div className="newInput">
                    <Select
                    id="cardExYY"
                    name="c_expiry_yy_U"
                    required
                    value={this.state.expiryYear}
                    onChange={this.handelExpiryYearChange}
                    validations={[required]}
                    >
                        <option value="" disabled>YY</option>
                        <option value="21">2021</option>
                        <option value="22">2022</option>
                        <option value="23">2023</option>
                        <option value="24">2024</option>
                        <option value="25">2025</option>
                        <option value="26">2026</option>
                        <option value="27">2027</option>
                        <option value="28">2028</option>
                        <option value="29">2029</option>
                        <option value="30">2030</option>
                    </Select>
                </div>
            </div>
            <div className="col-md-4 col-sm-12 col-xs-12">
                <div className="newInput">
                    <Input type="number"
                    pattern="[0-9]*"
                    id="cardCVV"
                    name="c_cvv_U"
                    placeholder="CVV"
                    required
                    value={this.state.cvv}
                    onChange={(e) => {e.target.value.length <= 4 ?  this.handelCVVChange(e) : this.handelCVVValueChange(e.target.value.slice(0, 4))}}
                    validations={[required, Cvv]}
                    />
                </div>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12">
                <h3>Choose your bank</h3>
                <div className='container_div'>
                    {this.state.userData.bank_installment.map((ele, index) => (
                        <div className={`bank ${this.state.active_bank == index? "active" : "" }`} key={index} onClick={(e)=> {this.handleChooseBank(index)}}>
                            <p>{ele.name}</p>
                            <img src={ele.logo} />
                        </div>
                    ))}
                </div>
                <h3>Choose your installment plan</h3>
                <div className='container_div'>
                    {this.state.userData.bank_installment[this.state.active_bank] &&
                        this.state.userData.bank_installment[this.state.active_bank].plans.map((ele, index) => (
                            <div className={`plan ${this.state.active_plan == index? "active" : "" }`} key={index} onClick={(e)=> {this.handleChoosePlan(ele.tenure, index)}}>
                                <p>{ele.emi/100} {this.state.userData.order_currency} / {ele.tenure} Months</p>
                            </div>
                        ))
                    }
                    {/* {this.state.userData.bank_installment[this.state.active_bank].plans.map((ele, index) => (
                        <div className={`plan ${this.state.active_plan == index? "active" : "" }`} key={index} onClick={(e)=> {this.handleChoosePlan(ele.tenure, index)}}>
                            <p>{ele.emi/100} {this.state.userData.order_currency} / {ele.tenure} Months</p>
                        </div>
                    ))} */}
                </div>
            </div>
        </div>
        <div className='text-center cardFooter'>
            {(
                this.state.active_bank == null ||
                this.state.active_plan == null
            ) ?
                <button className="confirmBtnNew" disabled={true}>PAY NOW</button>
            :
                <Button className="confirmBtnNew">PAY NOW</Button>
            }
            <span>
                <i className="fa fa-lock"></i>
                Secured by Paymob
            </span>
        </div>
    </Form>
  )
  render() {
    return (
        <div className="cardNew">
            <h3>Add your card information</h3>
                {this.state.waiting?
                    <Waiting height='311px' />
                :
                    this.renderForm()
                }
        </div>
    );
  }
}

export default installments;
